import { Component } from '@angular/core';

@Component({
    selector: 'app-no-access',
    templateUrl: './no-access.component.html',
    standalone: false
})
export class NoAccessComponent {
}
